import './downloads.scss';

class Downloads {
    constructor (element) {
        this.$downloads = element;
        this.$input = this.$downloads.querySelectorAll('[data-download="input"]');
    }

    init () {
        this.setActiveTab();
    }

    setActiveTab () {
        if (this.$input.length >= 1) {
            for (let i = 0; i < this.$input.length; i++) {
                this.$input[i].addEventListener('click', (e) => {
                    if (this.$input[i].checked) {
                        this.$input.forEach((input) => {
                            if (input !== this.$input[i]) {
                                input.checked = false;
                            }
                        });
                    }

                    const elementPosition = e.target.parentElement.offsetTop;
                    const $anchorNavigation = document.querySelector('.anchor-navigation');
                    const $mobileInfoHeader = document.querySelector('.site-header__info.mobile');
                    let topPosition = elementPosition;
                    if ($anchorNavigation) {
                        const anchorNavigationHeight = $anchorNavigation.offsetHeight;
                        topPosition = topPosition - anchorNavigationHeight;
                    }
                    if ($mobileInfoHeader) {
                        if ($mobileInfoHeader.style.display !== 'none') {
                            const mobileInfoHeaderHeight = $mobileInfoHeader.offsetHeight;
                            topPosition = topPosition - mobileInfoHeaderHeight;
                        }
                    }
                    window.scroll({ left: 0, top: topPosition, behavior: 'smooth' });
                });
            }
        }
    }
}

export { Downloads };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $downloads = $context.querySelectorAll('[data-download="root"]');
        for (let i = 0; i < $downloads.length; i++) {
            const $download = new Downloads($downloads[i]);
            $download.init($downloads[i]);
        }
    }
});
